import { isDesktop } from "./device";

const hostInfo = () => {
  let host: string = (typeof window !== 'undefined' ? window.ama?.hostName || window.location.hostname : '').toLowerCase();

  if (host.startsWith('www.')) {
    host = host.slice(4);
  }
  return {
    domain: host,
    siteName: host.split('.')[0],
  };
};

const { siteName, domain } = hostInfo();

export const dkSeenthisStyles = () => {
  // Config map for domain-specific styling
  const getDomainStyles = (domain: string): string => {
    switch (domain) {
      case 'spisbedre.dk':
        return `
          body.high-impact-topscroll-rendered [data-type="ad"]:has(.high-impact-ad-wrapper-topscroll) {
            position: absolute;
            top: calc(-70vh - 90px);
            left: 0;
            height: 0 !important;
          }
        `;

      case 'femina.dk':
        return `
          body.high-impact-topscroll-rendered {
            padding-top: 70vh;
          }
  
          body.high-impact-topscroll-rendered [data-type="ad"]:has(.high-impact-ad-wrapper-topscroll) {
            position: absolute;
            top: -70vh;
            left: 0;
            height: 0 !important;
          }
        `;
      case 'udeoghjemme.dk':
        return `
          body.high-impact-topscroll-rendered {
            padding-top: 70vh;
          }
  
          body.high-impact-topscroll-rendered [data-type="ad"]:has(.high-impact-ad-wrapper-topscroll) {
            position: absolute;
            top: -70vh;
            left: 0;
            height: 0 !important;
          }
          body.high-impact-topscroll-rendered #header-main {
            margin-top: 0vh !important;
          }
        `;
      case 'vielskerserier.dk':
        return `
          body.high-impact-topscroll-rendered {
            padding-top: 70vh;
          }
  
          body.high-impact-topscroll-rendered [data-type="ad"]:has(.high-impact-ad-wrapper-topscroll) {
            ${isDesktop() ? "margin-left: calc((960px - 100vw) / 2);" : ""}
            position: absolute;
            top: -70vh;
            left: 0;
            height: 0 !important;
          }
        `;
      default:
        return `
          body.high-impact-topscroll-rendered {
            padding-top: 70vh;
          }
  
          body.high-impact-topscroll-rendered [data-type="ad"]:has(.high-impact-ad-wrapper-topscroll) {
            position: absolute;
            top: -70vh;
            left: 0;
            height: 0 !important;
          }
        `;
    }
  };

  let customStyles = '';

  customStyles = getDomainStyles(domain);

  customStyles += `
    body.high-impact-topscroll-rendered #slug {
      padding-top: 0;
    }
    body.high-impact-topscroll-rendered #slug::before {
      content: "";
      display: block;
      height: 20px;
      width: 100%;
      background-color: white;
      position: relative;
      z-index: 6;
    }
    body.high-impact-topscroll-rendered .flex.justify-center {
      position: relative;
    }
  `;
  return customStyles;

}
export const getBettingStatus = (): 'yes' | 'no' => {
  const bettingSites = new Set([
    'familiejournal',
    'udeoghjemme',
    'billedbladet',
    'seoghoer',
  ]);

  return bettingSites.has(siteName) ? 'yes' : 'no';
};

export const getDKPathIdExceptions: PathIdExceptions = {
  'familiejournal.dk': 'familiejournal',
  'spisbedre.dk': 'Spisbedre_2018',
  'femina.dk': 'femina',
  'udeoghjemme.dk': 'udeoghjemme',
  'seoghoer.dk': 'seoghoer.dk',
  'billedbladet.dk': 'billedbladet',
  'vielskerserier.dk': 'vielskerserier',
  'isabellas.dk': 'isabellas.dk',
};
